import { getBusinessTypeOptions } from '../content/business-types';

function getDefaultFields(businessType = 'Restaurant') {
  return [
    {
      label: 'Contact Name',
      name: 'contactName',
      required: true,
      placeholder: 'Your Name',
    },
    {
      label: 'Mobile Phone Number',
      name: 'contactPhone',
      required: true,
      placeholder: '(123) 456-7890',
      type: 'phoneInput',
    },
    {
      label: 'Contact Email',
      name: 'contactEmail',
      required: true,
      placeholder: 'you@gmail.com',
      type: 'email',
    },
    {
      label: `${businessType} Name`,
      name: 'businessName',
      required: true,
      placeholder: `My Business`,
      type: 'businessSearch',
    },
  ];
}

const theOrderingAppFormFields = [
  {
    label: 'The Ordering.app Rep Name (Optional)',
    name: 'theOrderingAppRepName',
    required: false,
    placeholder: 'The Ordering.app Rep Name',
  },
  {
    label: 'The Ordering.app URL (Optional)',
    name: 'theOrderingAppUrl',
    required: false,
    placeholder: 'The Ordering.app URL',
  },
  {
    label: 'Customer Contact Name',
    name: 'contactName',
    required: true,
    placeholder: 'Name',
  },
];

const ezCaterFormFields = [
  {
    label: 'ezCater Rep Name (Optional)',
    name: 'ezcaterRepName',
    required: false,
    placeholder: 'ezCater Rep Name',
  },
  {
    label: 'Restaurant Contact Name',
    name: 'contactName',
    required: true,
    placeholder: 'Restaurant Contact Name',
  },
];

const helloAliceFormFields = [
  {
    label: 'Your Name',
    name: 'contactName',
    required: true,
    placeholder: 'Your Name',
  },
];

const harborTouchFormFields = [
  {
    label: 'Harbortouch Rep Name (Optional)',
    name: 'harbortouchRepName',
    required: false,
    placeholder: 'Harbortouch Rep Name',
  },
  {
    label: 'Harbortouch Rep Email (Optional)',
    name: 'harbortouchRepEmail',
    required: false,
    placeholder: 'Harbortouch Rep Email',
    type: 'email',
  },
  {
    label: 'Customer Contact Name',
    name: 'contactName',
    required: true,
    placeholder: 'Name',
  },
];

const cloverFormFields = [
  {
    label: 'Clover Rep Name',
    name: 'cloverRepName',
    required: false,
    placeholder: 'Clover Rep Name',
  },
  {
    label: 'Clover Rep Email',
    name: 'cloverRepEmail',
    required: false,
    placeholder: 'Clover Rep Email',
    type: 'email',
  },
  {
    label: 'Clover ID (Optional)',
    name: 'mid',
    required: false,
    placeholder: 'MID',
  },
];

const bbotFormFields = [
  {
    label: 'Bbot Rep Name (Optional)',
    name: 'bbotRepName',
    required: false,
    placeholder: 'Bbot Rep Name',
  },
  {
    label: 'Bbot Rep Email (Optional)',
    name: 'bbotRepEmail',
    required: false,
    placeholder: 'Bbot Rep Email',
    type: 'email',
  },
  {
    label: 'Customer Contact Name',
    name: 'contactName',
    required: true,
    placeholder: 'Name',
  },
];

const syscoFormFields = [
  {
    label: 'Sales Consultant Name',
    name: 'syscoRepName',
    required: false,
    placeholder: 'Sales Consultant Name',
  },
  {
    label: 'Sales Consultant Email',
    name: 'syscoRepEmail',
    required: false,
    placeholder: 'Sales Consultant Email',
  },
  {
    label: 'Sysco Customer Account Number',
    name: 'syscoCustomerAccountNumber',
    required: true,
    placeholder: 'Account Number',
  },
];

const toastFormFields = [
  {
    label: 'Toast Rep Name (Optional)',
    name: 'toastRepName',
    required: false,
    placeholder: 'Toast Rep Name',
  },
  {
    label: 'Toast Rep Email (Optional)',
    name: 'toastRepEmail',
    required: false,
    placeholder: 'Toast Rep Email',
    type: 'email',
  },
];

const propelrFormFields = [
  {
    label: 'Propelr Rep Name (Optional)',
    name: 'propelrRepName',
    required: false,
    placeholder: 'Propelr Rep Name',
  },
  {
    label: 'Propelr Rep Email (Optional)',
    name: 'propelrRepEmail',
    required: false,
    placeholder: 'Propelr Rep Email',
    type: 'email',
  },
];

const daysmartFormFields = [
  {
    label: 'DaySmart Rep Name',
    name: 'daySmartRepName',
    required: false,
    placeholder: 'DaySmart Rep Name',
  },
  {
    label: 'DaySmart Rep Email',
    name: 'daySmartRepEmail',
    required: false,
    placeholder: 'DaySmart Rep Email',
    type: 'email',
  },
];

const alignableFields = [
  {
    label: 'Business Type',
    name: 'businessType',
    required: true,
    type: 'select',
    placeholder: 'Business Type',
    options: getBusinessTypeOptions(),
  },
];

const genericFields = [
  ...getDefaultFields('Business'),
  {
    label: 'Business Type',
    name: 'businessType',
    required: true,
    type: 'select',
    placeholder: 'Select Business Type',
    options: getBusinessTypeOptions(),
  },
  {
    label: 'How did you hear about us?',
    name: 'discoverySource',
    required: false,
    type: 'select',
    placeholder: 'e.g. Facebook, Google Search, Word of Mouth',
    options: [
      {
        key: 'friend',
        value: 'Friend or fellow business owner',
        text: 'Friend or fellow business owner',
      },
      { key: 'socialMedia', value: 'Social media', text: 'Social media' },
      {
        key: 'pos',
        value: 'An online ordering or POS company',
        text: 'An online ordering or POS company',
      },
      {
        key: 'fisherman',
        value: 'An existing Fisherman website',
        text: 'An existing Fisherman website',
      },
      { key: 'blog', value: 'Blog post or Press article', text: 'Blog post or Press article' },
      { key: 'conference-or-event', value: 'Conference or Event', text: 'Conference or Event' },
      { key: 'other', value: 'Other', text: 'Other' },
    ],
  },
];

const boulevardFields = [
  {
    label: 'Boulevard Rep Name (Optional)',
    name: 'boulevardRepName',
    required: false,
    placeholder: 'Boulevard Rep Name',
  },
  {
    label: 'Boulevard Rep Email (Optional)',
    name: 'boulevardRepEmail',
    required: false,
    placeholder: 'Boulevard Rep Email',
    type: 'email',
  },
  {
    label: 'Merchant Contact Name',
    name: 'contactName',
    required: true,
    placeholder: 'Name',
  },
  {
    label: ' Merchant Mobile Phone Number',
    name: 'contactPhone',
    required: true,
    placeholder: 'Mobile Phone Number',
    type: 'phoneInput',
  },
  {
    label: 'Merchant Contact Email',
    name: 'contactEmail',
    required: true,
    placeholder: 'Email',
    type: 'email',
  },
  {
    label: `Business Name`,
    name: 'businessName',
    required: true,
    placeholder: `Business Name`,
    type: 'businessSearch',
  },
];

const shift4FormFields = [
  {
    label: 'Shift4 Rep Name (Optional)',
    name: 'shift4RepName',
    required: false,
    placeholder: 'Shift4 Rep Name',
  },
  {
    label: 'Shift4 Rep Email (Optional)',
    name: 'shift4RepEmail',
    required: false,
    placeholder: 'Shift4 Rep Email',
    type: 'email',
  },
];

export const formFields = {
  default: genericFields,
  theorderingapp: [...theOrderingAppFormFields, ...getDefaultFields().slice(1)],
  ezcater: [...ezCaterFormFields, ...getDefaultFields().slice(1)],
  helloalice: [...helloAliceFormFields, ...getDefaultFields().slice(1)],
  onevalley: [...helloAliceFormFields, ...getDefaultFields().slice(1)],
  harbortouch: [...harborTouchFormFields, ...getDefaultFields().slice(1)],
  bbot: [...bbotFormFields, ...getDefaultFields().slice(1)],
  clover: [...cloverFormFields, ...getDefaultFields().slice(0)],
  toast: [...toastFormFields, ...getDefaultFields()],
  toastCustomers: [...getDefaultFields()],
  propelr: [...propelrFormFields, ...getDefaultFields()],
  sysco: [...syscoFormFields, ...getDefaultFields()],
  clovermarketplace: [...getDefaultFields()],
  daysmart: [...daysmartFormFields, ...getDefaultFields('Business')],
  alignable: [...getDefaultFields('Business'), ...alignableFields],
  'daysmart-website': [...getDefaultFields('Business')],
  boulevard: [...boulevardFields],
  shift4: [...shift4FormFields, ...getDefaultFields()],
};
